import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const NameSection = () => (
  <section className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-32" data-testid="name-section">
    <div className="grid gap-12 lg:grid-cols-12">
      <div className="lg:col-span-7">
        <p className="eyebrow mb-8">( The name )</p>
        <motion.h2 initial="hidden" whileInView="show" viewport={{ once: true, amount: 0.15 }}
          className="font-display text-4xl uppercase leading-[1.02] text-zinc-50 sm:text-6xl lg:text-7xl">
          {["So why the name", "Clean As Fuck", "Cleaning Co.?"].map((l, i) => (
            <span key={l} className="block overflow-hidden pb-[0.04em]">
              <motion.span variants={{ hidden: { y: "105%" }, show: { y: 0 } }}
                transition={{ duration: 1, delay: i * 0.12, ease: EASE }}
                className={`block ${i === 1 ? "font-serif-i normal-case text-acid" : ""}`}>{l}</motion.span>
            </span>
          ))}
        </motion.h2>
      </div>
      <div className="flex flex-col gap-6 pt-2 lg:col-span-5 lg:pt-16">
        <motion.p initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.8, delay: 0.2, ease: EASE }} className="text-lg leading-relaxed text-zinc-300">
          Because &ldquo;Pretty Tidy LLC&rdquo; was taken. Because &ldquo;Sparkle &amp; Shine&rdquo; made us gag.
          And because when we finish your place, &ldquo;wow&rdquo; just doesn&apos;t cover it — you&apos;re going to
          need <span className="font-serif-i text-xl text-zinc-50">stronger words.</span> So we made them the brand.
        </motion.p>
        <motion.p initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.8, delay: 0.3, ease: EASE }} className="text-base leading-relaxed text-zinc-400">
          &ldquo;Clean as fuck&rdquo; isn&apos;t swagger. Okay — it&apos;s a little swagger. Mostly it&apos;s the
          standard: when we leave, your space looks so good that swearing about it is just{" "}
          <span className="font-serif-i text-lg text-zinc-50">accurate reporting.</span> Go ahead. Say it.
        </motion.p>
        <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.8, delay: 0.4 }} className="font-mono-x text-xs leading-relaxed tracking-wide text-zinc-500">
          ( AND YES — IT&apos;S ON THE PAPERWORK. WE LIKE TO SAY LLC STANDS FOR LUXURY. LUMINOUS. CLEAN. )
        </motion.p>
      </div>
    </div>
  </section>
);
